import { Injectable, OnDestroy, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SubSink } from 'subsink';
import { ProjectModel } from '../../../../../core/models/project/project.model';
import { StatusModel } from '../../../../../core/models/project/status.model';
import {
  NotificationType,
  ShiveNotificationService,
} from '../../../../../core/services/controls/shive-notification.service';
import { ProjectsHttpService } from '../../../../../core/state/projects/projects-http.service';
import { ProjectDataService } from '../../state-and-data-handling/project-data.service';

@Injectable({
  providedIn: 'root',
})
export class ManageProjectService implements OnDestroy {
  // Form Groups
  public projectBaseForm: FormGroup;

  // DI
  private readonly projectsHttpService = inject(ProjectsHttpService);
  private readonly projectDataService = inject(ProjectDataService);
  private readonly shiveNotificatioService = inject(ShiveNotificationService);

  private readonly subs = new SubSink();

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public emitManageProjectHttpRequests(): boolean {
    const projectClone = this.projectDataService.getProjectClone();
    if (this.formsValid() && projectClone.projectMemberPropertiesWrapper.length > 0) {
      this.sendPostOrPutRequests(projectClone);
      return true;
    }

    if (projectClone.projectMemberPropertiesWrapper.length === 0) {
      this.shiveNotificatioService.show(
        NotificationType.Error,
        'At least one member must be present.',
      );
    }
    return false;
  }

  public initNewProject(statuses: StatusModel[]): void {
    // User creates new project.
    const project = new ProjectModel();
    project.id = -1;
    project.name = '';
    project.tasks = [];
    project.projectMemberPropertiesWrapper = [];
    project.client = null;
    project.status = statuses[0];
    project.startsAt = new Date();
    project.endsAt = new Date();
    this.projectDataService.addProject(project);
  }

  private formsValid(): boolean {
    this.projectBaseForm.markAllAsTouched();
    return this.projectBaseForm.valid;
  }

  private sendPostOrPutRequests(project: ProjectModel): void {
    if (project.id >= 0) {
      this.projectsHttpService.updateProject(project);
    } else {
      this.projectsHttpService.addProject(project);
    }
  }
}
